import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import { GetLogrosObj, LogroObj } from '@/objects/Gamificacion';
import RowLogro from '@/components/elements/listas/lista_logros/RowLogro';
import Subtitulo from '@/components/elements/Subtitulo';

function Logros() {

    const { gamificationQueries } = useServices();

    const [logros, setLogros] = React.useState<LogroObj[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        cargar();
    }, []);


    function cargar() {
        const datosUsuario = cargarDatosUsuario();
        gamificationQueries?.obtenerLogrosPorIdUser(Number(datosUsuario?.id_user)).then((response: AxiosResponse<GetLogrosObj>) => {
            //alert(JSON.stringify(response.data));
            const logrosTotales: LogroObj[] = response.data.listaLogros;
            setLogros(logrosTotales);
        }
        ).catch((error: any) => {

        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.logros.titulo")} />
            <Subtitulo texto={t("menu:secciones.logros.descripcion")} />
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                {logros.map((logro: LogroObj, index: number) => {
                    return <RowLogro key={index} logro={logro} t={t} />
                })}
            </section>
        </section>
    );
}

export default Logros;